
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guide/domande-frequenti",
      function () {
        return require("private-next-pages/guide/domande-frequenti/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guide/domande-frequenti"])
      });
    }
  